/* Submit the original form so quantity, validation and cart feedback stay shared. */
if (!customElements.get('objectiv-product-buy-bar')) {
  customElements.define('objectiv-product-buy-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.button = this.querySelector('button');
      this.form = this.button?.form;
      this.source = this.form?.querySelector('[type="submit"]');
      if (!this.source) return;
      this.label = this.querySelector('[data-buy-bar-label]');
      this.idleLabel = this.label.textContent;
      this.status = this.querySelector('[role="status"]');
      this.purchase = this.form.closest('objectiv-shop-quick-add');
      const sync = () => {
        this.button.disabled = this.source.disabled;
        this.button.toggleAttribute('aria-busy', this.source.hasAttribute('aria-busy'));
        if (this.source.hasAttribute('aria-busy')) this.button.setAttribute('aria-busy', 'true');
        const label = this.purchase.querySelector('[data-cart-label]');
        this.label.textContent = label && !label.children.length ? label.textContent : this.idleLabel;
        this.status.textContent = this.classList.contains('is-visible') && this.purchase.dataset.cartState !== 'added'
          ? this.purchase.querySelector('[role="status"]').textContent : '';
      };
      const update = bottom => {
        // Crossing the bottom edge of the viewport must never show the bar.
        const visible = bottom <= 0;
        if (this.classList.contains('is-visible') === visible) return;
        if (!visible && this.contains(document.activeElement)) this.source.focus({ preventScroll: true });
        this.classList.toggle('is-visible', visible);
        this.inert = !visible;
        this.setAttribute('aria-hidden', String(!visible));
        sync();
      };
      this.observer = new IntersectionObserver(([entry]) => update(entry.boundingClientRect.bottom), { threshold: 0 });
      this.observer.observe(this.source);
      // A large jump can skip intersection entirely (below viewport -> above).
      this.onScroll = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          update(this.source.getBoundingClientRect().bottom);
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.state = new MutationObserver(sync);
      this.state.observe(this.purchase, { attributes: true, childList: true, subtree: true });
      sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.state?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = 0;
      this.observer = null;
      this.classList.remove('is-visible');
      this.inert = true;
      this.setAttribute('aria-hidden', 'true');
    }
  });
}
